import { sagas as referralsSagas } from './modules/referrals'

export default [...referralsSagas]
